module.exports = __webpack_public_path__ + "img/new9.a857ea03.png";